module.exports = __webpack_public_path__ + "img/logo.f5433798.png";